import clsx from 'clsx';
import { saveAs } from 'file-saver';
import React from 'react';
import { getDataIdGenerator } from '../../../../core/utils/generateDataId';
import QueryOutputTable from '../../../query-output-table/components/query-output-table/QueryOutputTable';
import { HdIcon, HdIconButton, HdTooltip } from '../../../../components';
import { getQueryResultCSV } from '../../utils/workbench';

export interface QueryResultBoxProps {
  className?: string;
  showingInsideCard?: boolean;
  hasMoreResults?: boolean;
  queryOutput: any;
  isExpandedView?: boolean;
  useVirtualScrolling?: boolean;
  toggleExpandedView: Function;
}

const QueryOutputTableMemoized = React.memo(QueryOutputTable);

export function QueryResultBox({
  className,
  hasMoreResults,
  queryOutput,
  useVirtualScrolling,
  showingInsideCard,
  isExpandedView,
  toggleExpandedView
}: QueryResultBoxProps) {
  const rowCount = queryOutput?.rows.length;

  const downloadQueryOutput = () => {
    const csvData = getQueryResultCSV(queryOutput);

    const blob = new Blob([ csvData ], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'query_result.csv');
  };

  const boxClasses = clsx(
    'box box--table flex-col',
    showingInsideCard ? 'box--inside-card' : '',
    className
  );

  const dataIdGenerator = getDataIdGenerator('workbench-query-result');

  return (
    <div className={boxClasses}>
      <div className='box__header'>
        <div className='box__title'>
          Query Results
          {hasMoreResults ? (
            <HdTooltip
              title={`Showing first ${rowCount} rows from the query output`}
              placement='right'
            >
              <HdIcon
                name='info'
                className='info-icon'
              />
            </HdTooltip>
          ) : null}
        </div>

        <div className='box__header__actions'>
          <HdTooltip title={isExpandedView ? 'Collapse Table' : 'Expand Table'}>
            <HdIconButton
              dataId={dataIdGenerator('toggle-expand')}
              onClick={() => toggleExpandedView()}
            >
              <HdIcon name={isExpandedView ? 'small-screen' : 'full-screen'} />
            </HdIconButton>
          </HdTooltip>

          <HdTooltip title='Download'>
            <HdIconButton
              className='ml-1'
              dataId={dataIdGenerator('download')}
              onClick={() => downloadQueryOutput()}
            >
              <HdIcon name='download' />
            </HdIconButton>
          </HdTooltip>
        </div>
      </div>

      <div className='box__body scroll-x flex-1'>
        <QueryOutputTableMemoized
          output={queryOutput}
          useVirtualScrolling={useVirtualScrolling}
          canShowJSONDialog={!isExpandedView}
        />
      </div>
    </div>
  );
}
